import menu1 from "../../assests/menu-2.png"
import menu2 from "../../assests/home-slide-3.png"
import popular1 from "../../assests/restaurant-1/popular-1.png"
import popular2 from "../../assests/restaurant-1/popular-2.png"
import popular3 from "../../assests/restaurant-1/popular-3.png"
import dish1 from "../../assests/restaurant-1/dish-1.png"
import dish2 from "../../assests/restaurant-1/dish-2.png"
import dish3 from "../../assests/restaurant-1/dish-3.png"
import { restaurant1Menu } from "./restaurant1"

export const featuredHotels = [
    {
        id:1,
        image: menu1,
        title:"67 Athi hotel",
        descr:"Summer house, Athi river",
        delivery:"free",
        time:32,
        rate:4.2,
        review: 325,
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:2,
        image: menu2,
        title:"The white resort",
        descr:"Sumbulah road",
        delivery:"20$",
        time:25,
        rate:3.9,
        review: 421,
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:3,
        image: menu1,
        title:"67 Athi hotel",
        descr:"Summer house, Athi river",
        delivery:"free",
        time:32,
        rate:4.2,
        review: 122,
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
    {
        id:4,
        image: menu2,
        title:"The white resort",
        descr:"Sumbulah road",
        delivery:"20$",
        time:25,
        rate:3.9,
        review: 178,
        menu: restaurant1Menu,
        foodType: ["Deshi food", "African", "Kenyan"],
        popularFood:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: popular1,
                title:"Cookie sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 500,
                type: "Chinese",
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: popular2,
                title:"Combo burger",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 399,
                type: "Chinese",
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: popular3,
                title:"Combo sandwich",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price: 450,
                type: "Chinese",
            },
        ],
        bestDishes:[
            {
                id:1,
                resTitle: "67 Authi hotel",
                image: dish1,
                title:"Canape",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:200,
                type: "Chinese"
            },
            {
                id:2,
                resTitle: "67 Authi hotel",
                image: dish2,
                title:"Relishes & Crudite",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:199,
                type: "Chinese"
            },
            {
                id:3,
                resTitle: "67 Authi hotel",
                image: dish3,
                title:"Chips & Dips",
                descr:"Shortbread, chocolate turtle cookies, and red velvet.",
                price:345,
                type: "Chinese"
            },
        ],
    },
]